/**
 * HH:mm 문자열을 split해 시간/분 반환
 *
 * @param value HH:mm 포맷의 문자열
 * @param fallback value가 falsy인 경우 fallback값 (default: [0,0])
 * @returns
 */
export const getTime = (
  value?: string,
  fallback?: [number, number]
): number[] => {
  if (!value) {
    return fallback ?? [0, 0];
  }

  const [hour, minute] = value.split(':');
  return [Number(hour), Number(minute)];
};
